"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceWithFeeInt = priceWithFeeInt;
exports.priceWithFee = priceWithFee;
function priceWithFeeInt(price, ach) {
    if (ach)
        return Math.round(price + 500);
    return Math.round((price + 30) / (1 - 0.022));
}
function priceWithFee(price) {
    return Number(((price + 0.3) / (1 - 0.022)).toFixed(2));
}
